export const PressReleaseId = 'PressReleaseId';

export enum PressReleaseAttributes {
  DATE = 'pressReleaseDate',
  SUBLINE = 'pressReleaseSubline',
  HEADLINE = 'pressReleaseHeadline',
  HEADLINE_ELEMENT = 'pressReleaseHeadlineElement',
  BUTTONS = 'pressReleaseButtonGroup',
}
